import { render, staticRenderFns } from "./system-customer-form.vue?vue&type=template&id=52d2d3fc"
import script from "./system-customer-form.vue?vue&type=script&lang=js"
export * from "./system-customer-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports